import { Avatar, Box, Typography, alpha } from '@mui/material';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import { brand } from 'src/theme/brand';

type ShopBrandMarkProps = {
  shopName?: string;
  shopLogoUrl?: string;
  shopInitial?: string;
  variant?: 'header' | 'sidebar';
};

const ShopBrandMark = ({
  shopName,
  shopLogoUrl,
  shopInitial = 'S',
  variant = 'header'
}: ShopBrandMarkProps) => {
  const isSidebar = variant === 'sidebar';

  return (
    <Box display="flex" alignItems="center" gap={1.25} minWidth={0}>
      <Avatar
        src={shopLogoUrl}
        alt={shopName || 'Shop logo'}
        variant="rounded"
        sx={{
          width: isSidebar ? 40 : 36,
          height: isSidebar ? 40 : 36,
          borderRadius: isSidebar ? '12px' : '10px',
          bgcolor: alpha(brand.blue, 0.12),
          color: brand.blue,
          border: `1px solid ${alpha(brand.slate, isSidebar ? 0.12 : 0.08)}`,
          fontWeight: 700,
          fontSize: 14,
          flexShrink: 0
        }}
      >
        {shopLogoUrl ? null : shopInitial || <StorefrontRoundedIcon sx={{ fontSize: 20 }} />}
      </Avatar>
      <Box minWidth={0}>
        <Typography
          noWrap
          sx={{
            fontWeight: 700,
            fontSize: isSidebar ? 15 : 14,
            letterSpacing: '-0.02em',
            lineHeight: 1.2,
            color: 'text.primary'
          }}
        >
          {shopName || 'My Shop'}
        </Typography>
        <Typography
          noWrap
          sx={{
            fontSize: isSidebar ? 11 : 12,
            fontWeight: 500,
            color: 'text.secondary',
            letterSpacing: isSidebar ? '0.04em' : 0,
            textTransform: isSidebar ? 'uppercase' : 'none'
          }}
        >
          {isSidebar ? 'Shop portal' : 'Shop dashboard'}
        </Typography>
      </Box>
    </Box>
  );
};

export default ShopBrandMark;
